<template>
    <div
      class="mb-9 mt-4 grid grid-cols-order__top place-content-center gap-x-14px gap-y-24px"
    >
      <!-- Rhomb #1 -->
      <div
        v-if="['Manager', 'Studio', 'Hosd', 'Check'].includes(role)"
        class="relative cursor-pointer text-center uppercase group w-28 h-28 m-auto transition-all duration-300 ease-in-out"
        @click="()=> {setRombick('new'), getArchive}"
      >
        <div
          class="overflow-hidden w-full h-full transition duration-300 ease-in-out"
        >
          <svg
            class="z-2 relative mt-5 w-5 h-5 fill-white mx-auto group-hover:w-6 group-hover:h-6 transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#status-1"></use>
          </svg>
          <h2
            class="text-2xl z-2 relative mt-1 text-white group-hover:text-3xl transition-all duration-300"
          >
            {{this.new }}
          </h2>
          <svg
            class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 fill-status-1 group-hover:w-full group-hover:h-full transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#bg-romb"></use>
          </svg>
        </div>
        <span
          class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-4 opacity-100 text-status-20 font-latobold"
        >
          Новые
        </span>
      </div>
  
      <!-- Rhomb #2 -->
      <div
        v-if="['Logist', 'Studio', 'Hosd', 'Check'].includes(role)"
        class="relative cursor-pointer text-center uppercase group w-28 h-28 m-auto transition-all duration-300 ease-in-out"
        @click="setRombick('req'), getArchive"
      >
        <div
          class="overflow-hidden w-full h-full transition duration-300 ease-in-out"
        >
          <svg
            class="z-2 relative mt-5 w-5 h-5 fill-white mx-auto group-hover:w-6 group-hover:h-6 transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#status-19"></use>
          </svg>
          <h2
            class="text-2xl z-2 relative mt-1 text-white group-hover:text-3xl transition-all duration-300"
            
          >
            {{this.req }}
          </h2>
          <svg
            class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 fill-black group-hover:w-full group-hover:h-full transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#bg-romb"></use>
          </svg>
        </div>
        <span
          class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-4 opacity-100 text-status-20 font-latobold"
          >Рекламация</span
        >
      </div>
  
      <!-- Rhomb #3
      <div
        v-if="['Manager', 'Client'].includes(role)"
        class="relative cursor-pointer text-center uppercase group w-28 h-28 m-auto transition-all duration-300 ease-in-out"
        @click="filterDoc()"
      >
        <div
          class="overflow-hidden w-full h-full transition duration-300 ease-in-out"
        >
          <svg
            class="z-2 relative mt-5 w-5 h-5 fill-white mx-auto group-hover:w-6 group-hover:h-6 transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#doc"></use>
          </svg>
          <h2
            class="text-2xl z-2 relative mt-1 text-white group-hover:text-3xl transition-all duration-300"
            
          >
            {{ OrderCounter.count["doc"] }}
          </h2>
          <div
            v-if="OrderCounter.vio['doc']"
            class="w-4 h-4 z-2 relative mx-auto"
          >
            <svg class="w-full h-full fill-white">
              <use xlink:href="@/assets/i.svg#status-11"></use>
            </svg>
          </div>
          <svg
            class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 fill-status-13 group-hover:w-full group-hover:h-full transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#bg-romb"></use>
          </svg>
        </div>
        <span
          class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-4 opacity-100 text-status-20 font-latobold"
          >Документы
        </span>
      </div> -->
  
      <!-- Rhomb #3 -->
      <div
        v-if="['Manager', 'Logist', 'Studio', 'Hosd', 'Client'].includes(role)"
        class="relative cursor-pointer text-center uppercase group w-28 h-28 m-auto transition-all duration-300 ease-in-out"
        @click="setRombick('min')"
      >
        <div
          class="overflow-hidden w-full h-full transition duration-300 ease-in-out"
        >
          <svg
            class="z-2 relative mt-5 w-5 h-5 fill-white mx-auto group-hover:w-6 group-hover:h-6 transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#ico-edit"></use>
          </svg>
          <h2
            class="text-2xl z-2 relative mt-1 text-white group-hover:text-3xl transition-all duration-300"
            
          >
            {{ this.min }}
          </h2>
          <svg
            class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 fill-status-12 group-hover:w-full group-hover:h-full transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#bg-romb"></use>
          </svg>
        </div>
        <span
          class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-4 opacity-100 text-status-20 font-latobold"
          >Активация</span
        >
      </div>
  
      <!-- Rhomb #4 -->
      <!-- <div 
              class="relative cursor-pointer text-center uppercase group w-28 h-28 m-auto transition-all duration-300 ease-in-out"
              @click="filterPayStatus"
          >
              <div class="overflow-hidden w-full h-full transition duration-300 ease-in-out">
                  <svg class="z-2 relative mt-5 w-5 h-5 fill-white mx-auto group-hover:w-6 group-hover:h-6 transition-all duration-300">
                      <use xlink:href="@/assets/i.svg#bill-6"></use>
                  </svg>
                  <h2 
                      class="text-2xl z-2 relative mt-1 text-white group-hover:text-3xl transition-all duration-300" 
                      >{{ OrderCounter.count[13] }}
                  </h2>
                  <svg class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 fill-status-13 group-hover:w-full group-hover:h-full transition-all duration-300">
                      <use xlink:href="@/assets/i.svg#bg-romb"></use>
                  </svg>
              </div>
              <span class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-4 opacity-100 text-status-20 font-latobold">Оплата</span>
          </div> -->
  
      <!-- Rhomb #5 -->
      <div
        class="relative cursor-pointer text-center uppercase group w-28 h-28 m-auto transition-all duration-300 ease-in-out"
        @click="setRombick('delay')"
      >
        <div
          class="overflow-hidden w-full h-full transition duration-300 ease-in-out"
        >
          <svg
            class="z-2 relative mt-5 w-5 h-5 fill-white mx-auto group-hover:w-6 group-hover:h-6 transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#status-10"></use>
          </svg>
          <h2
            class="text-2xl z-2 relative mt-1 text-white group-hover:text-3xl transition-all duration-300"
            
          >
            {{ this.delay }}
          </h2>
          <svg
            class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 fill-status-10 group-hover:w-full group-hover:h-full transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#bg-romb"></use>
          </svg>
        </div>
        <span
          class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-4 opacity-100 text-status-20 font-latobold"
          >Отложены</span
        >
      </div>
  
      <!-- Rhomb #6 -->
      <div
        class="relative cursor-pointer text-center uppercase group w-28 h-28 m-auto transition-all duration-300 ease-in-out"
        @click="setRombick('ass')"
      >
        <div
          class="overflow-hidden w-full h-full transition duration-300 ease-in-out"
        >
          <svg
            class="z-2 relative mt-5 w-5 h-5 fill-white mx-auto group-hover:w-6 group-hover:h-6 transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#status-3"></use>
          </svg>
          <h2
            class="text-2xl z-2 relative mt-1 text-white group-hover:text-3xl transition-all duration-300"
            
          >
            {{ this.ass }}
          </h2>
          <svg
            class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 fill-status-2 group-hover:w-full group-hover:h-full transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#bg-romb"></use>
          </svg>
        </div>
        <span
          class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-4 opacity-100 text-status-20 font-latobold"
          >Назначены</span
        >
      </div>
  
      <!-- Rhomb #7 -->
      <div
        v-if="['Logist', 'Studio', 'Hosd', 'Master', 'Client'].includes(role)"
        class="relative cursor-pointer text-center uppercase group w-28 h-28 m-auto transition-all duration-300 ease-in-out"
        @click="setRombick('comp')"
      >
        <div
          class="overflow-hidden w-full h-full transition duration-300 ease-in-out"
        >
          <svg
            class="z-2 relative mt-5 w-5 h-5 fill-white mx-auto group-hover:w-6 group-hover:h-6 transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#status-5"></use>
          </svg>
          <h2
            class="text-2xl z-2 relative mt-1 text-white group-hover:text-3xl transition-all duration-300"
            
          >
            {{ this.comp}}
          </h2>
          <svg
            class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 fill-status-5 group-hover:w-full group-hover:h-full transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#bg-romb"></use>
          </svg>
        </div>
        <span
          class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-4 opacity-100 text-status-20 font-latobold"
          >Завершены</span
        >
      </div>
  
      <div
        v-if="
          ['Manager', 'Logist', 'Studio', 'Hosd', 'Check', 'Finance'].includes(
            role
          )
        "
        class="relative cursor-pointer text-center uppercase group w-28 h-28 m-auto transition-all duration-300 ease-in-out"
        @click="setRombick('cancel')"
      >
        <div
          class="overflow-hidden w-full h-full transition duration-300 ease-in-out"
        >
          <svg
            class="z-2 relative mt-5 w-5 h-5 fill-white mx-auto group-hover:w-6 group-hover:h-6 transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#ico-no"></use>
          </svg>
          <h2
            class="text-2xl z-2 relative mt-1 text-white group-hover:text-3xl transition-all duration-300"
            
          >
            {{ this.cancel }}
          </h2>
          <svg
            class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 fill-status-7 group-hover:w-full group-hover:h-full transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#bg-romb"></use>
          </svg>
        </div>
        <span
          class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-4 opacity-100 text-status-20 font-latobold"
          >ОТКАЗ</span
        >
      </div>
  
      <!-- Rhomb #8 -->
      <div
        v-if="
          ['Logist', 'Master', 'Studio', 'Hosd', 'Client', 'Check'].includes(role)
        "
        class="relative cursor-pointer text-center uppercase group w-28 h-28 m-auto transition-all duration-300 ease-in-out"
        @click="setRombick('to')"
      >
        <div
          class="overflow-hidden w-full h-full transition duration-300 ease-in-out"
        >
          <svg
            class="z-2 relative mt-5 w-5 h-5 fill-white mx-auto group-hover:w-6 group-hover:h-6 transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#ico-ok"></use>
          </svg>
          <h2
            class="text-2xl z-2 relative mt-1 text-white group-hover:text-3xl transition-all duration-300"
            
          >
            {{ this.to }}
          </h2>
          <svg
            class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 fill-status-6 group-hover:w-full group-hover:h-full transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#bg-romb"></use>
          </svg>
        </div>
        <span
          v-if="['Check'].includes(role)"
          class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-4 opacity-100 text-status-20 font-latobold"
          >Ждут КК</span
        >
        <span
          v-else
          class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-4 opacity-100 text-status-20 font-latobold"
          >Проверены ТО</span
        >
      </div>
  
      <!-- Rhomb #9 -->
      <!-- <template v-if="['Logist', 'Master', 'Client', 'Check'].includes(role)">
        <div
          class="relative cursor-pointer text-center uppercase group w-28 h-28 m-auto transition-all duration-300 ease-in-out"
          @click="filterStatus(8)"
        >
          <div
            class="overflow-hidden w-full h-full transition duration-300 ease-in-out"
          >
            <svg
              class="z-2 relative mt-5 w-5 h-5 fill-white mx-auto group-hover:w-6 group-hover:h-6 transition-all duration-300"
            >
              <use xlink:href="@/assets/i.svg#status-8"></use>
            </svg>
            <h2
              class="text-2xl z-2 relative mt-1 text-white group-hover:text-3xl transition-all duration-300"
              
            >
              {{ OrderCounter.count[8] }}
            </h2>
            <svg
              class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 fill-status-6 group-hover:w-full group-hover:h-full transition-all duration-300"
            >
              <use xlink:href="@/assets/i.svg#bg-romb"></use>
            </svg>
          </div>
          <span
            class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-4 opacity-100 text-status-20 font-latobold"
            >KK</span
          >
        </div>
      </template> -->
  
      <!-- 
          <div v-if="role != 'Client'" class="round f_red btn show" @click="filterStatus(19)">
              <div class="item">
                  <svg class="ico"><use xlink:href="@/assets/i.svg#status-11"></use></svg>
                  <h2 >{{ OrderCounter.count[19] }}</h2>
                  <svg class="romb"><use xlink:href="@/assets/i.svg#bg-romb"></use></svg>
              </div>
              <span class="name">Нарушения</span>
          </div>
      -->
    </div>
    <div class="pb-4 w-full flex flex-row flex-wrap items-center justify-end">
  <!-- Основная строка с поиском и элементами -->
  <div class="flex-grow min-w-[300px]">
    <!-- Строка с количеством и поиском -->
    <div class="flex flex-row items-end w-full">
      <div class="mr-2 mt-3">
        <h2 class="h-9 min-w-[2.25rem] w-auto border border-teal-700 mt-2 rounded-lg p-2 mb-2 text-center">
          <span class="w-full text-lg leading-none text-teal-700">
            {{ this.countOrders }}
          </span>
        </h2>
      </div>
      <div class="flex-grow mb-2">
        <input
          type="text"
          class="h-9 w-full py-2 px-3 text-sm bg-slate-50"
          placeholder="Название"
          v-model="searchInput"
        />
      </div>
    </div>
    
    <!-- Строка с иконками и создателем -->
    <div class="flex flex-row justify-end items-center w-full">
      <template v-if="['Manager', 'Logist', 'Studio', 'Hosd', 'Check'].includes(role)">
        <div class="relative mx-5px group" @click="setPikcha(1)">
          <svg class="duration-300 fill-gray-400 w-6 h-6 hover:fill-status-5 cursor-pointer">
            <use xlink:href="@/assets/i.svg#pay-1"></use>
          </svg>
          <span class="absolute -top-7 left-1/2 -translate-x-2/4 text-xs uppercase bg-slate-100 px-2 py-1 group-hover:visible group-hover:opacity-100 opacity-0 invisible duration-150 transition ease-linear">Нал</span>
        </div>
        <div class="relative mx-5px group" @click="setPikcha(2)">
          <svg class="duration-300 fill-gray-400 w-6 h-6 hover:fill-status-5 cursor-pointer">
            <use xlink:href="@/assets/i.svg#pay-2"></use>
          </svg>
          <span class="absolute -top-7 left-1/2 -translate-x-2/4 text-xs uppercase bg-slate-100 px-2 py-1 group-hover:visible group-hover:opacity-100 opacity-0 invisible duration-150 transition ease-linear">Безнал</span>
        </div>
      </template>

      <div class="relative mx-5px group" @click="setPikcha(3)">
        <svg class="duration-300 fill-gray-400 w-6 h-6 hover:fill-status-5 cursor-pointer">
          <use xlink:href="@/assets/i.svg#nav-service"></use>
        </svg>
        <span class="absolute -top-7 left-1/2 -translate-x-2/4 text-xs uppercase bg-slate-100 px-2 py-1 group-hover:visible group-hover:opacity-100 opacity-0 invisible duration-150 transition ease-linear">Тахограф</span>
      </div>
      <div class="relative mx-5px group" @click="setPikcha(4)">
        <svg class="duration-300 fill-gray-400 w-6 h-6 hover:fill-status-5 cursor-pointer">
          <use xlink:href="@/assets/i.svg#ico-time"></use>
        </svg>
        <span class="absolute -top-7 left-1/2 -translate-x-2/4 text-xs uppercase bg-slate-100 px-2 py-1 group-hover:visible group-hover:opacity-100 opacity-0 invisible duration-150 transition ease-linear">Мониторинг</span>
      </div>
      
      <select class="px-3 h-9 bg-slate-50 ml-2" v-model="uid">
        <option selected value="" disabled>Создатель</option>
        <template v-for="m in selectManagers" :key="m">
          <option :value="m.uid">{{ m.secondname }} {{ m.name }}</option>
        </template>
      </select>
    </div>
  </div>

  <!-- Блоки с датами -->
  <div class="flex flex-col items-center justify-start ml-2">
    <p class="text-center">Дата создания</p>
    <div class="flex flex-col">
      <input
        class="h-9 px-3 mb-2 bg-slate-50"
        type="date"
        v-model="dateCreateStart"
      />
      <input
        class="h-9 px-3 bg-slate-50"
        type="date"
        v-model="dateCreateEnd"
      />
    </div>
  </div>
  
  <div class="flex flex-col items-center justify-between ml-2">
    <p class="text-center">Дата назначения</p>
    <div class="flex flex-col">
      <input
        class="h-9 px-3 mb-2 bg-slate-50"
        type="date"
        v-model="dateAssignedStart"
      />
      <input
        class="h-9 px-3 bg-slate-50"
        type="date"
        v-model="dateAssignedEnd"
      />
    </div>
  </div>

  <!-- Блоки с менеджерами -->
  <template v-if="['Manager', 'Logist', 'Studio', 'Hosd', 'Check'].includes(role)">
    <div class="flex flex-col mt-5 ml-2">
      <select
        class="h-9 px-3 mb-2 bg-slate-50"
        v-model="manager"
      >
        <option selected value="" disabled>Менеджер</option>
        <template v-for="m in selectManagers" :key="m">
          <option :value="m.uid">{{ m.secondname }} {{ m.name }}</option>
        </template>
      </select>

      <select
        class="h-9 px-3 bg-slate-50"
        v-model="master"
      >
        <option selected value="" disabled>Инженер</option>
        <option v-for="m in selectMasters" :key="m.uid" :value="m.uid">
          {{ m.secondname }} {{ m.name }}
        </option>
      </select>
    </div>
  </template>

  <!-- Кнопки -->
  <div class="flex flex-col mt-5 ml-2">
    <div
      class="v-btn duration-100 transition ease-linear"
      style="align-items: center; display: flex"
      :class="{ 'bg-green-500 text-white': changed, 'bg-gray-300': !changed }"
      @click="getArchive"
    >
      Поиск
      <svg
        :class="{ 'fill-white': changed }"
        class="ml-4 w-5 h-5 group-focus-within:fill-green-500 transition duration-150"
      >
        <use xlink:href="@/assets/i.svg#ico-search"></use>
      </svg>
    </div>
    <div
      class="v-btn duration-100 transition ease-linear mt-2"
      style="align-items: center; display: flex"
      :class="{ 'bg-gray-500 text-white': clean, 'bg-gray-300': !clean }"
      @click="Clear()"
    >
      Сброс
      <svg
        :class="{ 'fill-white': changed }"
        class="ml-4 w-5 h-5 group-focus-within:fill-green-500 transition duration-150"
      >
        <use xlink:href="@/assets/i.svg#ico-no"></use>
      </svg>
    </div>
  </div>
</div>

<select v-model="itemsInPage" style="padding: 7px" @change="getArchive()">
    <option value="10">10</option>
    <option value="20">20</option>
    <option value="50">50</option>
    <option value="100">100</option>
  </select>
  <Paginator :count="pageCount" v-model="page" :click="getArchive" />
  <div style="position: relative">
    <div
      class="w-full bg-white v-bgray2 mb-4 overflow-hidden rounded-xl relative overflow-x-auto"
    >
      <div
        class="title-grid items-center h-10 v-bbgray px-4 uppercase min-w-full"
      >
        <div
          class="font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px]"
        >
         Статус
        </div>
        <div
          class="font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px]"
        >
          №
        </div>
        <div
          class="font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px] text-center"
        >
          Дата
        </div>
        <div
          class="font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px]"
        >
          <div
            class="font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px]"
          >
            Клиент
          </div>
        </div>
        <div
          class="font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px] text-center"
        >
          Менеджер
        </div>
        <div
          class="font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px] text-center"
        >
          Инженер
        </div>
        <div
          class="font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px] text-center"
        >
          Номер ТС
        </div>
      </div>
    </div>
</div>
  <div
    v-if="showList"
    class="w-full bg-white v-bgray2 mb-8 overflow-hidden rounded-xl relative overflow-x-auto"
  >
    <template v-for="item in ArchOrderList.orders" :key="item">
      <a
        class="grid grid-cols-order px-4 py-2 gap-2 v-bbgray bg-teal-light odd:bg-white items-center transition duration-300 cursor-pointer hover:shadow-v1 max-2xl:grid-cols-order_m max-2xl:auto-rows-[50px]"
        :class="'status-' + item.status"
        @click="showOrder(item)"
      >
        <div class="flex w-16">
          <template v-if="item.violate">
            <div class="w-5 h-5">
              <svg class="w-full h-full ml-2 fill-status-11">
                <use xlink:href="@/assets/i.svg#status-11"></use>
              </svg>
            </div>
          </template>
          <template v-else>
            <div class="w-5 h-5 mr-2">
              <LineIco :status="parseInt(item.status)" />
            </div>
          </template>

          <template v-if="item.r_id > 0">
            <div class="w-5 h-5">
              <svg class="w-full h-full ml-2 fill-black">
                <use xlink:href="@/assets/i.svg#status-19"></use>
              </svg>
            </div>
          </template>

          <template v-if="item.act == 3">
            <div class="w-5 h-5">
              <svg class="w-full h-full ml-2 fill-status-6">
                <use xlink:href="@/assets/i.svg#status-6"></use>
              </svg>
            </div>
          </template>
          <template v-if="item.act == 4">
            <div class="w-5 h-5">
              <svg class="w-full h-full ml-2 fill-status-4">
                <use xlink:href="@/assets/i.svg#ico-mail"></use>
              </svg>
            </div>
          </template>
          <template v-if="item.act == 7">
            <div class="w-5 h-5">
              <svg class="w-full h-full ml-2 fill-status-7">
                <use xlink:href="@/assets/i.svg#status-7"></use>
              </svg>
            </div>
          </template>
          <template v-if="item.act == 8">
            <div class="w-5 h-5">
              <svg class="w-full h-full ml-2 fill-status-8">
                <use xlink:href="@/assets/i.svg#status-8"></use>
              </svg>
            </div>
          </template>
        </div>

        <div class="mr-4 text-black w-10">#{{ item.iid }}</div>

        <template v-if="['Master'].includes(role)">
          <div
            v-if="item.dates[0]?.date"
            class="flex items-center col-span-2 max-m:col-span-2"
          >
            <svg class="fill-status-6 min-w-[1rem] w-4 h-4 mr-2">
              <use xlink:href="@/assets/i.svg#ico-time"></use>
            </svg>
            <div class="text-black text-sm">
              {{ moment(item.dates[0]?.date).format("DD.MM") }}
              {{ item.dates[0]?.start?.slice(0, 5) }}
            </div>
          </div>
        </template>

        <div v-else class="items-center col-span-2 max-m:col-span-2">
          <div
            v-if="item.dates && item.dates[0]?.date"
            class="flex items-center mb-1"
          >
            <svg class="fill-status-6 min-w-[1rem] w-4 h-4 mr-2">
              <use xlink:href="@/assets/i.svg#ico-time"></use>
            </svg>
            <div class="text-black text-sm">
              {{ moment(item.dates[0]?.date).format("DD.MM") }}
              {{ item.dates[0]?.start?.slice(0, 5) }}
            </div>
          </div>
          <div class="flex items-center ml-2">
            <svg class="fill-gray-400 w-2 h-2 mr-1 rotate-45">
              <use xlink:href="@/assets/i.svg#ico-no"></use>
            </svg>
            <div class="text-gray-400 text-xs">
              {{ moment(item.create_at).format("DD.MM.YYYY") }}
            </div>
          </div>
        </div>

        <template v-if="role == 'Client'">
          <div class="items-center col-span-4">
            <div
              class="mr-4 flex w-full h-full items-center v-gray font-latoblod-serif"
            >
              <span
                class="text-white w-11 h-11 mr-4 text-xl leading-none rounded-full flex items-center justify-center min-w-[44px]"
                :class="'bg-status-' + item.status"
                >{{ item.mark?.slice(0, 1) }}</span
              >
              {{ item.mark }}
              <span
                v-if="item.num"
                class="text-slate-600 w-auto rounded-sm v-tsnum ml-2 px-2 py-1 text-base"
              >
                {{ item.num }}
              </span>
            </div>
          </div>
        </template>

        <template v-else>
          <div
            v-if="item.status == 10"
            class="text-black mr-4 flex w-full h-full items-center col-span-4 max-m:col-span-4"
          >
            <span
              class="text-white w-11 h-11 mr-4 text-xl leading-none rounded-full flex items-center justify-center min-w-[44px] bg-status-20"
              :class="{
                '!bg-status-7': item.delay == 1,
                '!bg-status-10': item.delay == 2,
                '!bg-status-5': item.delay == 3,
              }"
            >
              {{ item.cname?.slice(0, 1) }}
            </span>
            <div class="flex flex-col justify-center overflow-hidden pr-4">
              <span
                class="text-[10px] leading-none"
                :class="{
                  '!text-red-500': item.delay == 1,
                  ' text-yellow-500': item.delay == 2,
                  'text-green-500': item.delay == 3,
                }"
                >{{ delay[item.delay] }}</span
              >
              <span
                class="text-base font-semibold break-all max-h-10 leading-5"
                >{{ item.cname }}</span
              >
            </div>
            <svg v-if="item.vip" class="h-5 w-5 fill-gray">
              <use xlink:href="@/assets/i.svg#ico-vip"></use>
            </svg>
            <img v-if="item.new && !currentDate.isAfter(moment(item.new).add(3, 'months'))" class="h-10 w-10 fill-gray ml-2" src="@/assets/new.svg" />
          </div>
          <div
            v-else
            class="text-black mr-4 flex w-full h-full items-center col-span-4 max-m:col-span-4"
          >
            <span
              class="text-white w-11 h-11 mr-4 text-xl leading-none rounded-full flex items-center justify-center min-w-[44px]"
              :class="'bg-status-' + item.status"
            >
              {{ item.cname?.slice(0, 1) }}
            </span>
            <div class="flex flex-col justify-center overflow-hidden pr-4">
              <!-- <span class="text-[10px] text-gray-400 leading-none">КЛИЕНТ</span> -->
              <span
                class="text-base font-semibold break-all max-h-10 leading-5"
                >{{ item.cname }}</span
              >
            </div>
            <svg v-if="item.vip" class="h-5 w-5 fill-gray">
              <use xlink:href="@/assets/i.svg#ico-vip"></use>
            </svg>
            <img v-if="item.new && !currentDate.isAfter(moment(item.new).add(3, 'months'))" class="h-10 w-10 fill-gray ml-2" src="@/assets/new.svg" />
          </div>
        </template>

        <div
          v-if="['Manager', 'Logist', 'Master'].includes(role)"
          class="text-black text-xs tex-left max-h-16 px-4 col-span-2 max-m:col-span-4"
        >
          <span v-if="item.box">Бокс</span>
          <span v-else>{{ item.address }}</span>
        </div>

        <template v-if="!['Manager', 'Logist'].includes(role)">
          <div
            v-if="item.mname"
            class="font-latoblod-serif font-[16px] text-v-gray relative flex justify-start items-center col-span-2 max-m:col-span-2"
          >
            <div
              class="min-w-[1.5rem] rounded-full mr-3 overflow-hidden"
              :class="'bg-status-' + item.status"
            >
              <IcoPic :pic="item.mpicture" :name="item.mname" />
            </div>
            <div class="flex flex-col justify-center overflow-hidden">
              <span class="text-[10px] text-gray-400 leading-none uppercase"
                >Менеджер</span
              >
              <span class="text-black overflow-hidden">{{ item.mname }}</span>
            </div>
          </div>
          <div
            v-else
            class="flex justify-start items-center col-span-2 max-m:col-span-2"
          >
            <span
              class="w-11 h-11 bg-slate-200 flex justify-center rounded-full items-center overflow-hidden mr-2"
            >
              <svg class="w-4 h-4 fill-white">
                <use xlink:href="@/assets/i.svg#ico-avatar"></use>
              </svg>
            </span>
          </div>
        </template>

        <template v-if="role != 'Master'">
          <div
            v-if="item.wname"
            class="font-latoblod-serif font-[16px] flex justify-start items-center col-span-2 max-m:col-span-2"
          >
            <div
              class="min-w-[1.5rem] rounded-full mr-3 overflow-hidden"
              :class="'bg-status-' + item.status"
            >
              <IcoPic :pic="item.wpicture" :name="item.wname" />
            </div>
            <div class="flex flex-col justify-center overflow-hidden">
              <span class="text-[10px] text-gray-400 leading-none uppercase"
                >Инженер</span
              >
              <span class="text-black">{{ item.wname }}</span>
            </div>
          </div>
          <div
            v-else
            class="flex justify-start items-center col-span-2 max-m:col-span-2"
          >
            <span
              class="w-11 h-11 bg-slate-200 flex justify-center rounded-full items-center overflow-hidden mr-2"
            >
              <svg class="w-4 h-4 fill-white">
                <use xlink:href="@/assets/i.svg#ico-avatar"></use>
              </svg>
            </span>
          </div>
        </template>

        <template v-if="role != 'Client'">
          <div
            class="min-w-[90px] v-gray font-latoblod-serif col-span-2 max-m:col-span-2"
          >
            <span
              v-if="item.num"
              class="block text-center text-slate-600 w-full min-w-full rounded-sm v-tsnum px-2 py-1 text-xs uppercase"
            >
              {{ item.num }}
            </span>
          </div>
        </template>
      </a>
    </template>
  </div>      
  </template>
  
  <script>
  import { mapActions, mapGetters } from "vuex";
  import moment from "moment";
//   import { toRaw } from "vue";
// import TouchEdit from "./TouchEdit.vue";
  import LineIco from "../components/ui/LineIco.vue";
  import Paginator from "@/components/ui/Paginator";
  
  export default {
    name: "OrderList",
  
    components: { LineIco, Paginator },
  
    data() {
      return {
        moment: moment,
        page: 2,
        itemsInPage: "10",
        year:  new Date().getFullYear(),
        showList: false,
        manager: "",
        master: "",
        dateCreateStart: "",
        dateCreateEnd: "",
        dateAssignedStart: "",
        dateAssignedEnd: "",
        searchInput: "",
        new: 0,
        req: 0,
        min: 0,
        delay: 0,
        ass: 0,
        comp: 0,
        cancel: 0,
        to: 0,
        countOrders: 0,
        rombik: "all",
        uid: "",
        pikcha: "",
        currentDate: moment()
      };
    },
  
    computed: {
      ...mapGetters([
        "profile",
        "role",
        "roles",
        "ArchOrderList",
        "OrderCounter",
        "countOrders",
        "selectManagers",
        "selectMasters",
      ]),
      pageCount() {
      return Math.ceil(
        this.countOrders /
          this.itemsInPage
      );
    },
    },
  
    methods: {
      ...mapActions([
        "getOrderArhive",
        "setOrder",
        "showOrder",
        "setSettings",
      ]),
    
     async getArchive(){
        let formData = new FormData()
        formData.append('date_start', this.dateCreateStart )
        formData.append('date_end', this.dateCreateEnd )
        formData.append('date_ass_start', this.dateAssignedStart )
        formData.append('date_ass_end', this.dateAssignedEnd )
        formData.append('findme', this.searchInput )
        formData.append('page', this.page )
        formData.append('page_size', this.itemsInPage )
        formData.append('manager', this.manager )
        formData.append('master', this.master )
        formData.append('rombik', this.rombik )
        formData.append('uid', this.uid)
        formData.append('pikcha', this.pikcha)
        await this.getOrderArhive(formData)
        this.new = this.ArchOrderList.new
        this.req = this.ArchOrderList.req
        this.min = this.ArchOrderList.min
        this.delay = this.ArchOrderList.delay
        this.ass = this.ArchOrderList.ass
        this.comp = this.ArchOrderList.comp
        this.cancel = this.ArchOrderList.cancel
        this.to = this.ArchOrderList.to
        this.countOrders = this.ArchOrderList.count_orders

        this.showList = true
      },

      setRombick(value){
        this.rombik = value
        console.log(this.rombik)
        this.getArchive()
      },

      setPikcha(value){
        this.pikcha = value
        this.getArchive()
      },

      Clear(){
        this.manager = "",
        this.master = "",
        this.dateCreateStart = "",
        this.dateCreateEnd = "",
        this.dateAssignedStart = "",
        this.dateAssignedEnd = "",
        this.searchInput = "",
        this.new = 0,
        this.req = 0,
        this.min = 0,
        this.delay = 0,
        this.ass = 0,
        this.comp = 0,
        this.cancel = 0,
        this.to = 0,
        this.countOrders = 0,
        this.rombik = "all"
        this.pikcha = ''
        this.uid = ''
        this.getArchive()
      },
    },
  
    mounted() {
        this.getArchive()
    },
  };
  </script>
  
  <style>
      .month-report-top {
      padding: 12px 15px;
      border-radius: 4px;
      }
      .button-form-report {
        border-radius: 8px;
        background: #22c55e;
        border: none;
        color: #fff;
        text-align: center;
        font-size: 13.5px;
        font-weight: 700;
        line-height: 13.5px;
        text-transform: uppercase;
        padding: 15px 88px;
      }
      .title-grid {
        display: grid;
        grid-template-columns: 7.5% 0.2% 20.5% 25% 1fr 1fr 1fr;
        grid-template-rows: 1fr;
        grid-column-gap: 0px;
        grid-row-gap: 0px;
      }
  </style>